import React from 'react';
import { isNullOrUndefined } from "../../../store/storeFunctions";
import { Translate } from 'react-localize-redux';
import { withLocalize } from "react-localize-redux";
import AmlCandidatesFilter from './amlCandidatesFilter';
import AmlEntityData from './amlEntityData';
import Money from '../../common/moneyComponent';
import OldStyleSection from '../../common/oldStyleSection';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import RelationLink from '../relations/relationLink';
import Semaphore from './semaphore';
import moment from 'moment';
import BirthDateWithHighlight from '../../common/birthDateWithHighlight';

class AmlKeyOwnersEval extends React.Component {
    render() {
        return (
            <OldStyleSection name={this.props.translate("Report.Aml.Subjects.KeyOwners")} hasData={this.props.data && this.props.data.length > 0} isOpen isBold>
                {!this.props.isOnPath && <AmlCandidatesFilter section={this.props.section} hideRatioFilter={this.props.hideRatioFilter} />}
                <OldStyleTableWithHistory tableColumns={3} stripped
                    head={() => this.renderHead()}
                    actualData={this.props.data}
                    actualRow={(r) => this.props.isOnPath ? this.renderPathRow(r) : this.renderRow(r)}
                />
            </OldStyleSection>
        )
    }

    renderHead = () => {
        return (
            <thead className="aml-related-subjects-header">
                <tr>
                    <th><Translate id="Report.Aml.Subjects.MainName" /></th>
                    <th className="col-company-id"><Translate id="Report.Aml.Subjects.IcoBirthDate" /></th>
                    <th><Translate id="Report.Aml.Subjects.Position" /></th>
                    <th className="col-share-deposit"><Translate id="Report.Aml.Subjects.ShareDeposit" /></th>
                    <th className="col-valid-from"><Translate id="Report.Aml.Subjects.ValidFrom" /></th>
                    <th className="col-country"><Translate id="Report.Relations.Country" /></th>
                    <th className="col-aml">AML</th>
                </tr>
            </thead>
        );
    }

    renderRow = (r) => {
        return (
            <React.Fragment key={r.key}>
                <tr className="colorize">
                    <td style={{ fontWeight: "bold" }}><RelationLink wrap entityName={`${r.name || ""} ${r.surname || ""}`.trim()} entityId={r.entityId} reports={r.reports} customPrefix={<></>} showOnMobile={true} /></td>
                    <td>{r.type === "physicalPerson" ?<BirthDateWithHighlight dateAsString={r.birthDateFormatted} isFullDate={!r.isNotFullBirthDate} />  : r.companyId}</td>
                    <td>{r.position}</td>
                    <td>
                        {(r.share) && <>{r.share}%</>}
                        {((r.share > 0) && (r.deposit > 0)) && " / "}
                        {(r.deposit > 0) && <Money value={r.deposit} fractionDigits={0} currency={r.currency} />}
                    </td>
                    <td style={{ textAlign: "right" }}>{r.validFromFormatted}</td>
                    <td title={r.country}>{r.countryCode}</td>
                    <td style={{ textAlign: "center" }}><Semaphore color={r.decision} width={20} height={20} /></td>
                </tr>
                {r.candidates && r.candidates.length > 0 && <tr>
                    <td className="nested-table" colSpan={7}>
                        <AmlEntityData candidates={r.candidates} section={this.props.section} hasBirthDate={!isNullOrUndefined(r.birthDate)} />
                    </td>
                </tr>}
            </React.Fragment>
        );
    }

    renderPathRow = (r) => {
        return (
            <React.Fragment key={r.subject.entityId}>
                <tr className="colorize">
                    <td style={{ fontWeight: "bold" }}><RelationLink wrap entityName={`${r.subject.name || ""} ${r.subject.surname || ""}`.trim()} entityId={r.subject.entityId} reports={r.subject.reports}  customPrefix={<></>} showOnMobile={true} /></td>
                    <td>{r.subject.type === "P" ? r.subject.birthDateFormatted : r.subject.companyId}</td>
                    <td>{r.relation.RelationName}</td>
                    <td>
                        {(r.relation.Share) && <>{r.relation.Share}%</>}
                        {((r.relation.Share > 0) && (r.relation.ShareDeposit > 0)) && " / "}
                        {(r.relation.ShareDeposit > 0) && <Money value={r.relation.ShareDeposit} fractionDigits={0} currency={r.relation.Currency} />}                    </td>
                    <td style={{ textAlign: "right" }}>{!isNullOrUndefined(r.relation.DataDate) ? moment(r.relation.DataDate).format("DD.MM.YYYY") : ""}</td>
                    <td title={r.subject.countryFullName}>{r.subject.country}</td>
                    <td style={{ textAlign: "center" }}>
                    <Semaphore color={r.subject.amlReport.decision.toLowerCase()} width={20} height={20} />
                    </td>
                </tr>
            </React.Fragment>
        );
    }

}

export default withLocalize(AmlKeyOwnersEval);